module.exports = __webpack_public_path__ + "static/media/handled.819176f8.svg";